import type { ICustomError, IError } from '../interfaces/error';

export const buildErrorFromResponse = (payload: ICustomError): IError => {
    const response = payload.error?.response;
    const data = response?.data;

    return {
        statusText: response?.statusText || '',
        status: response?.status || 0,
        category: data?.code?.category || '',
        code: data?.code?.code || '',
        message: data?.message,
        requestId: data?.requestId || '',
        sessionId: data?.sessionId || '',
        timestamp: data?.timestamp || '',
        url: response?.config?.url || '',
        userMessage: payload.userMessage,
    };
};
